export default __webpack_public_path__ + "static/media/Clínica-Estar-Bem.5a9fc577.png";